import IcError from '../../assets/image/ic_analysis_fail.svg';
import { useTranslation } from '../../hook/useTranslation';

function EmptyCase({ open, text }: { open: boolean; text?: string }) {
  const { t } = useTranslation();
  return (
    <div
      className={`w-full flex flex-col items-center justify-center transition-all duration-300 ease-in-out ${
        open ? 'opacity-100 max-h-[500px]' : 'opacity-0 max-h-0'
      }`}
    >
      <div className="grow pt-[30px] rounded-[10px] bg-white flex flex-col items-start justify-center px-[20px] w-full">
        {text && (
          <div className="flex justify-start items-center gap-2 mb-[16px]">
            <div className="font-[700] text-[20px] text-[#1C1C1C] text-left">{text}</div>
          </div>
        )}
        <div className="w-full flex justify-start items-center gap-2">
          <div className="w-full bg-[#f8f8f8] rounded-[16px] h-[100px] flex items-center justify-center gap-2">
            <img src={IcError} alt="error" className="w-[18px] h-[18px]" />
            <div className="font-[700] text-[18px]">{t('report.empty_case.title')}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EmptyCase;
